import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { ICampaign } from "@/types/campaign.type";

const API_URL = `${import.meta.env.VITE_API_URL}/campaigns`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getAllCampaigns(pageOptions?: { search?: string; status?: string }): Promise<ApiResponseType<ICampaign[]>> {
  let url = `${API_URL}/`;
  const queryParams = new URLSearchParams({});

  if (pageOptions?.search) {
    queryParams.append("search", pageOptions.search);
  }
  if (pageOptions?.status) {
    queryParams.append("status", pageOptions.status);
  }

  if (queryParams.toString()) {
    url = `${url}?${queryParams.toString()}`;
  }

  const result = (await makeRequestDebounced(url)) as ApiResponseType<ICampaign[]>;

  return result;
}

export async function createCampaign(data: Omit<ICampaign, '_id' | 'sentCount' | 'status'>): Promise<ApiResponseType<ICampaign>> {
  const url = `${API_URL}/`;

  const result = (await makeRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })) as ApiResponseType<ICampaign>;

  return result;
}

export async function updateCampaign(id: string, data: Partial<Omit<ICampaign, '_id' | 'sentCount' | 'status'>>): Promise<ApiResponseType<ICampaign>> {
  const url = `${API_URL}/${id}`;

  const result = (await makeRequest(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })) as ApiResponseType<ICampaign>;

  return result;
}

export async function deleteCampaign(id: string): Promise<ApiResponseType<void>> {
  const url = `${API_URL}/${id}`;

  const result = (await makeRequest(url, {
    method: "DELETE",
  })) as ApiResponseType<void>;

  return result;
}
